"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const errors_1 = require("@/common/errors");
const settlement_request_1 = require("@/room/settlement_request");
const _1 = require(".");
function default_1({ error, confirm, returnUrl, setSettlementRequestData, setValue, openCompanyRegisterDialog, openPublishAgreeDialog, }) {
    var _a, _b, _c, _d;
    const errorStatus = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
    const errorCode = (_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
    const amountErrorConfirm = (description) => {
        const replacePage = () => window.location.replace(returnUrl);
        (0, errors_1.alertConfirm)({ confirm, description }).then(replacePage).catch(replacePage);
    };
    if (errorStatus === 403)
        (0, errors_1.handle403Error)(error);
    else if (errorStatus === 400) {
        switch (errorCode) {
            case 40003:
                amountErrorConfirm(i18next_1.default.t('정산 가능한 금액이 없어요.'));
                break;
            case 40004:
                amountErrorConfirm(i18next_1.default.t('정산 가능한 금액을 확인해 주세요.'));
                break;
            case 40010:
            case 40011:
                (0, settlement_request_1.invalidateSettlementCompanyData)({ setSettlementRequestData, setValue });
                (0, _1.companyInfoErrorConfirm)({ confirm, openCompanyRegisterDialog });
                break;
            case 40012:
                setSettlementRequestData(prev => (Object.assign(Object.assign({}, prev), { channel_company_seller_publish_agree: false })));
                openPublishAgreeDialog();
                break;
            default:
                (0, errors_1.commonErrorConfirm)({ confirm, errorCode });
        }
    }
    else
        (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
}
exports.default = default_1;
